import { SquireApi } from '@water-web/types';

export class Repository {
  protected api: SquireApi = null;

  configure(api: SquireApi): void {
    this.api = api;
  }
}
